module.exports = __webpack_public_path__ + "img/spain-external-causes-male.633cd8e1.png";